import { render, staticRenderFns } from "./b1Step.vue?vue&type=template&id=71bf25ad&scoped=true&"
import script from "./b1Step.vue?vue&type=script&lang=js&"
export * from "./b1Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf25ad",
  null
  
)

export default component.exports